import store from "@/store";


export default {
    methods: {
        userCan(permissionRequested) {
            let returnValue = false;
            const user = store.getters["auth/getUser"];
            if(user.permissions && user.permissions.length) {
                user.permissions.forEach(permission => {
                    if(permission.name === permissionRequested) {
                        returnValue = true;
                    }
                });
                return returnValue;
            }
        },
        userHasAdmin() {
            const user = store.getters["auth/getUser"];
            return user && user.role === 'admin';
        },
    }
}